export default "__VITE_ASSET__C49$uxFV__"